import { useLocation, useNavigate } from "react-router-dom";
import { hasReturnLocation, navigateToReturnLocation } from "../../utils/locationReturnService";
import Button from "./Button";

interface BackButtonProps {
    useReturnLocation?: boolean;
}

const BackButton = ({ useReturnLocation = false }: BackButtonProps) => {
    const navigate = useNavigate();
    const location = useLocation();
    const showStoredReturnLocation = useReturnLocation && hasReturnLocation();

    if (location.key === 'default' && !showStoredReturnLocation) {
        return null;
    }

    return (
        <Button id="back-button"
            text="Back"
            icon={<i className="ri-arrow-left-s-line" />}
            iconLocation="start"
            className="small secondary hide-on-print"
            onClick={() => {
                if (useReturnLocation) {
                    navigateToReturnLocation(navigate, () => navigate(-1), {
                        replace: true
                    });
                    return;
                }

                navigate(-1);
            }} />
    )
};

export default BackButton;
